
<template>
  <i :class="['image-icon', name]" :style="{'color': color, 'font-size': size + 'px'}"></i>
</template>

<script>
export default {
  name: "Old5emo",
  status: "prototype",
  release: "1.0.0",
  props: {
    name: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 10,
    },
    color: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
@font-face {
	font-family: 'icomoon';
	src:url('../../assets/fonts/icomoon.eot?-bkw6sq');
	src:url('../../assets/fonts/icomoon.eot?#iefix-bkw6sq') format('embedded-opentype'),
      url('../../assets/fonts/icomoon.woff?-bkw6sq') format('woff'),
      url('../../assets/fonts/icomoon.ttf?-bkw6sq') format('truetype'),
      url('../../assets/fonts/icomoon.svg?-bkw6sq#icomoon') format('svg');
	font-weight: normal;
	font-style: normal;
}

[class^="icon-"], [class*=" icon-"] {
	font-family: 'icomoon';
	speak: none;
	font-style: normal;
	font-weight: normal;
	font-variant: normal;
	text-transform: none;
	line-height: 1;

	/* Better Font Rendering =========== */
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
.icon-happy-gee:before {
	content: "\e600";
}
.icon-happy-sleep:before {
	content: "\e601";
}
.icon-happy-wink:before {
	content: "\e602";
}
.icon-joy-gee:before {
	content: "\e603";
}
.icon-joy-open:before {
	content: "\e604";
}
.icon-joy-sleep:before {
	content: "\e605";
}
.icon-neutral-sleep:before {
	content: "\e606";
}
.icon-unhappy-sleep:before {
	content: "\e607";
}
.icon-wow-open:before {
	content: "\e608";
}

</style>
